import { type FunctionComponent } from 'react';
import { Divider } from '../../../../components/common-components/divider/divider.component';
import { QuickStartImageGrid } from '../../../../components/quickstart-image-grid/quickstart-image-grid.component';
import { type QuickStartImageGridLook } from '../../../../types/project.types';
import { FilterLooks } from '../filter-looks/filter-looks.component';

export type ViewAllFavoritesProps = {
	looks: QuickStartImageGridLook[];
	rooms: string[];
	styles: string[];
	update: (groupName: 'room' | 'style', value: string) => void;
};

export const ViewAllFavorites: FunctionComponent<ViewAllFavoritesProps> = ({ looks, rooms, styles, update }) => (
	<div className="bg-theme-white" data-testid="my-favorite-looks">
		<h2 className="flex theme-grey-darker fw2 f1-ns f2 lh-title-ns lh-solid w-100 justify-center mb3">MY FAVORITE LOOKS</h2>
		<div className="ma4">
			<Divider verticalSpacing={0} horizontalSpacing={0} />
		</div>
		<div className="mb4 mt3">
			<FilterLooks updateSelection={update} selectedStyles={styles} selectedRooms={rooms} isAllFavorites={true} />
		</div>
		<div className="ma4">
			<Divider verticalSpacing={0} horizontalSpacing={0} />
		</div>
		<QuickStartImageGrid
			looks={looks}
			containerClassName="flex flex-wrap flex-row ga2 ga0-l ma2"
			className="w-third-l pa2-l"
			showTitle={false}
			isShopByLookPage={true}
			isCarousel={false}
		/>
	</div>
);
